const GrayBackgroundBox = "rounded p-3 bg-white";
const TextBoxStyle = { height: "600px", overflowY: "auto" };

export { GrayBackgroundBox, TextBoxStyle };
